import React from 'react';
import { createHashRouter } from 'react-router-dom';
import LuminaApp from '../LuminaApp';

const router = createHashRouter([
  {
    path: '/',
    element: <LuminaApp />,
  }
]);

export default router;
